import LlmConversationMessage from "../../conversation/model/LlmConversationMessage";
import ConversationReflectionMessage from "./ConversationReflectionMessage";

export default class ConversationReflection extends createjs.EventDispatcher {
    /**
     * @constructor
     * @param {string} id 
     * @param {string} chapterId 
     * @param {number} maxPlayerTurns 
     */
    constructor(id, chapterId, maxPlayerTurns) {
        super();

        this._id = id;
        this._chapterId = chapterId;
        this._maxPlayerTurns = maxPlayerTurns;

        /** @type {LlmConversationMessage[]} */
        this._conversationHistoryForLLM = [];
        /** @type {ConversationReflectionMessage[]} */
        this._conversationHistoryForGame = [];
        this._summary = "";
        this._hasEnded = false;
        this._turns = 0;
    }

    get id() {
        return this._id;
    }

    get chapterId() {
        return this._chapterId;
    }

    get maxPlayerTurns() {
        return this._maxPlayerTurns;
    }

    get conversationHistoryForLLM() {
        return this._conversationHistoryForLLM;
    }

    get conversationHistoryForGame() {
        return this._conversationHistoryForGame;
    }

    get summary() {
        return this._summary;
    }

    set summary(value) {
        this._summary = value;
    }

    get turns() {
        return this._turns;
    }

    get hasEnded() {
        return this._hasEnded;
    }

    bumpTurns() {
        this._turns++;
    }

    end() {
        this._hasEnded = true;
    }

    /**
     * @param {Object} params
     * @param {LlmConversationMessage[]} params.llmConversationMessages
     * @param {ConversationReflectionMessage[]} params.gameConversationMessages 
     */
    addConversationHistory({ llmConversationMessages, gameConversationMessages }) {
        this._conversationHistoryForLLM.push(...llmConversationMessages);
        this._conversationHistoryForGame.push(...gameConversationMessages);

        const newMessagesEvent = new createjs.Event('messages');
        newMessagesEvent.llmConversationMessages = llmConversationMessages;
        newMessagesEvent.gameConversationMessages = gameConversationMessages;
        this.dispatchEvent(newMessagesEvent);
    }

    toObject() {
        return {
            id: this._id,
            chapterId: this._chapterId,
            maxPlayerTurns: this._maxPlayerTurns,
            conversationHistoryForLLM: this._conversationHistoryForLLM.map((message) => message.toObject()),
            conversationHistoryForGame: this._conversationHistoryForGame.map((message) => message.toObject()),
            summary: this._summary,
            hasEnded: this._hasEnded,
            turns: this._turns,
        };
    }

    load(data) {
        this._id = data.id;
        this._chapterId = data.chapterId;
        this._maxPlayerTurns = data.maxPlayerTurns;
        this._conversationHistoryForLLM = data.conversationHistoryForLLM.map((messageData) => LlmConversationMessage.fromObject(messageData));
        this._conversationHistoryForGame = data.conversationHistoryForGame.map((messageData) => ConversationReflectionMessage.fromObject(messageData));
        this._summary = data.summary;
        this._hasEnded = data.hasEnded;
        this._turns = data.turns;
    }
}
